import styled, { keyframes } from 'styled-components';

export const LogsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 1.5rem;
  min-height: 0;
  flex: 1;
  overflow-y: auto;
`;

export const FilterPanel = styled.div`
  background-color: rgb(255 255 255);
  border: 1px solid rgb(226 232 240);
  border-radius: 0.75rem;
  padding: 1.25rem 1.5rem;
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  flex-wrap: wrap;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06);
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  min-width: 160px;
  flex: 1;
`;

export const FilterLabel = styled.label`
  font-size: 12px;
  font-weight: 500;
  color: rgb(71 85 105);
  text-transform: uppercase;
  letter-spacing: 0.025em;
`;

export const FilterInput = styled.input`
  height: 36px;
  padding: 0.375rem 0.75rem;
  font-size: 13px;
  font-family: inherit;
  border-radius: 0.5rem;
  border: 1px solid rgb(226 232 240);
  background-color: rgb(248 250 252);
  color: rgb(15 23 42);
  outline: none;
  transition: all 0.15s ease;
  width: 100%;

  &:focus {
    border-color: rgb(5 150 105);
    background-color: rgb(255 255 255);
    box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.1);
  }

  &::-webkit-calendar-picker-indicator {
    opacity: 0.6;
    cursor: pointer;
  }
`;

export const FilterSelect = styled.select`
  height: 36px;
  padding: 0.375rem 0.75rem;
  font-size: 13px;
  font-family: inherit;
  border-radius: 0.5rem;
  border: 1px solid rgb(226 232 240);
  background-color: rgb(248 250 252);
  color: rgb(15 23 42);
  outline: none;
  cursor: pointer;
  transition: all 0.15s ease;
  width: 100%;

  &:focus {
    border-color: rgb(5 150 105);
    background-color: rgb(255 255 255);
    box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.1);
  }
`;

export const FilterActions = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: flex-end;
  flex-shrink: 0;
`;

export const SearchButton = styled.button`
  height: 36px;
  padding: 0 1.25rem;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  transition: all 0.15s ease;
  background: linear-gradient(135deg, rgb(5 150 105), rgb(4 120 87));
  color: white;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  box-shadow: 0 1px 4px rgba(5, 150, 105, 0.3);

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, rgb(4 120 87), rgb(3 99 71));
    box-shadow: 0 2px 8px rgba(5, 150, 105, 0.4);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ResetButton = styled.button`
  height: 36px;
  padding: 0 1rem;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  border-radius: 0.5rem;
  border: 1px solid rgb(226 232 240);
  cursor: pointer;
  transition: all 0.15s ease;
  background-color: rgb(255 255 255);
  color: rgb(100 116 139);
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;

  &:hover {
    background-color: rgb(248 250 252);
    border-color: rgb(203 213 225);
    color: rgb(71 85 105);
  }
`;

export const ResultsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const ResultsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ResultsCount = styled.span`
  font-size: 13px;
  color: rgb(100 116 139);
  font-weight: 500;
`;

export const LogsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1.5rem;
  background-color: rgb(248 250 252);
  border: 1px dashed rgb(203 213 225);
  border-radius: 0.75rem;
  gap: 0.75rem;
  color: rgb(148 163 184);
`;

export const EmptyStateIcon = styled.div`
  font-size: 2rem;
  opacity: 0.5;
`;

export const EmptyStateText = styled.p`
  font-size: 14px;
  color: rgb(100 116 139);
  margin: 0;
  text-align: center;
`;

export const EmptyStateSubText = styled.p`
  font-size: 12px;
  color: rgb(148 163 184);
  margin: 0;
  text-align: center;
`;

export const PaginationRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding-top: 0.5rem;
`;

export const PageButton = styled.button`
  height: 32px;
  min-width: 32px;
  padding: 0 0.625rem;
  font-size: 13px;
  font-family: inherit;
  border-radius: 0.375rem;
  border: 1px solid ${props => props.$active ? 'rgb(5 150 105)' : 'rgb(226 232 240)'};
  background-color: ${props => props.$active ? 'rgb(5 150 105)' : 'rgb(255 255 255)'};
  color: ${props => props.$active ? 'white' : 'rgb(71 85 105)'};
  cursor: pointer;
  transition: all 0.15s ease;
  font-weight: ${props => props.$active ? '600' : '400'};

  &:hover:not(:disabled) {
    background-color: ${props => props.$active ? 'rgb(4 120 87)' : 'rgb(248 250 252)'};
    border-color: ${props => props.$active ? 'rgb(4 120 87)' : 'rgb(203 213 225)'};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

/* Skeleton shimmer */

const shimmer = keyframes`
  0% { background-position: -600px 0; }
  100% { background-position: 600px 0; }
`;

export const SkeletonBase = styled.div`
  border-radius: 0.25rem;
  background: linear-gradient(
    90deg,
    rgb(241 245 249) 25%,
    rgb(226 232 240) 50%,
    rgb(241 245 249) 75%
  );
  background-size: 600px 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;
`;

export const SkeletonText = styled(SkeletonBase)`
  height: ${props => props.$h || '12px'};
  width: ${props => props.$w || '100%'};
  border-radius: 0.25rem;
`;

export const SkeletonCircle = styled(SkeletonBase)`
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 9999px;
  flex-shrink: 0;
`;

export const SkeletonButton = styled(SkeletonBase)`
  height: 28px;
  width: 90px;
  border-radius: 9999px;
  flex-shrink: 0;
`;

/* LogCard styles */

export const LogCard = styled.div`
  border-radius: 0.875rem;
  background: ${props => props.$loading
    ? 'rgb(255 255 255)'
    : props.$error
    ? 'linear-gradient(135deg, rgb(254 242 242) 0%, rgb(254 226 226) 100%)'
    : 'linear-gradient(135deg, rgb(236 253 245) 0%, rgb(209 250 229) 100%)'
  };
  border: 1px solid ${props => props.$loading
    ? 'rgb(226 232 240)'
    : props.$error
    ? 'rgb(252 165 165)'
    : 'rgb(167 243 208)'
  };
  padding: 1rem 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  box-shadow: ${props => props.$loading
    ? '0 1px 4px rgba(15, 23, 42, 0.06)'
    : props.$error
    ? '0 2px 8px rgba(220, 38, 38, 0.1)'
    : '0 2px 8px rgba(16, 185, 129, 0.12)'
  };
  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.2s ease;
  animation: fadeInSlideUp 0.35s ease-out;

  @keyframes fadeInSlideUp {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &:hover {
    box-shadow: ${props => props.$loading
      ? '0 1px 4px rgba(15, 23, 42, 0.06)'
      : props.$error
      ? '0 4px 14px rgba(220, 38, 38, 0.15)'
      : '0 4px 14px rgba(16, 185, 129, 0.2)'
    };
  }

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }
`;

export const LogCardLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
  min-width: 0;
`;

export const LogCardIcon = styled.div`
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 9999px;
  background: ${props => props.$error
    ? 'linear-gradient(135deg, rgb(239 68 68), rgb(220 38 38))'
    : 'linear-gradient(135deg, rgb(16 185 129), rgb(5 150 105))'
  };
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.1rem;
  flex-shrink: 0;
  box-shadow: ${props => props.$error
    ? '0 2px 6px rgba(220, 38, 38, 0.35)'
    : '0 2px 6px rgba(16, 185, 129, 0.35)'
  };
`;

export const LogCardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
  flex: 1;
`;

export const LogCardPatientName = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${props => props.$error ? 'rgb(185 28 28)' : 'rgb(4 120 87)'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LogCardMeta = styled.div`
  font-size: 12px;
  color: ${props => props.$error ? 'rgb(220 38 38)' : 'rgb(5 150 105)'};
  display: flex;
  align-items: center;
  gap: 0.375rem;
  flex-wrap: wrap;
`;

export const LogCardCategory = styled.span`
  font-weight: 500;
  color: ${props => props.$error ? 'rgb(185 28 28)' : 'rgb(4 120 87)'};
`;

export const LogCardDot = styled.span`
  color: ${props => props.$error ? 'rgb(252 165 165)' : 'rgb(110 231 183)'};
`;

export const LogCardMedication = styled.div`
  font-size: 12px;
  color: ${props => props.$error ? 'rgb(220 38 38)' : 'rgb(16 185 129)'};
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-top: 0.125rem;

  svg {
    font-size: 11px;
    flex-shrink: 0;
  }
`;

export const LogCardMedicationName = styled.span`
  font-weight: 600;
  color: ${props => props.$error ? 'rgb(185 28 28)' : 'rgb(4 120 87)'};
`;

export const LogCardMedicationDetails = styled.span`
  font-weight: 400;
  color: rgb(16 185 129);
`;

export const LogCardMedLoading = styled.span`
  color: rgb(110 231 183);
  font-style: italic;
`;

export const LogCardMedError = styled.span`
  color: rgb(220 38 38);
  font-style: italic;
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

export const LogCardPatientMessage = styled.div`
  font-size: 11px;
  color: ${props => props.$error ? 'rgb(220 38 38)' : 'rgb(100 116 139)'};
  margin-top: 0.25rem;
  font-style: italic;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 520px;
`;

export const LogCardRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;

  @media (max-width: 640px) {
    justify-content: stretch;
    width: 100%;
  }
`;

export const LogCardDate = styled.div`
  font-size: 12px;
  color: ${props => props.$error ? 'rgb(220 38 38)' : 'rgb(5 150 105)'};
  white-space: nowrap;
`;

export const ViewButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  border-radius: 9999px;
  padding: 0.4rem 0.875rem;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  border: 1px solid ${props => props.$error ? 'rgb(252 165 165)' : 'rgb(167 243 208)'};
  background-color: rgb(255 255 255);
  color: ${props => props.$error ? 'rgb(185 28 28)' : 'rgb(4 120 87)'};
  font-family: inherit;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  &:hover {
    background-color: ${props => props.$error ? 'rgb(254 242 242)' : 'rgb(236 253 245)'};
    border-color: ${props => props.$error ? 'rgb(248 113 113)' : 'rgb(110 231 183)'};
    box-shadow: ${props => props.$error
      ? '0 2px 6px rgba(220, 38, 38, 0.15)'
      : '0 2px 6px rgba(16, 185, 129, 0.15)'
    };
  }
`;

export const LogCardRequestTypeBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0 6px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #b44a2e;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 3px;
  line-height: 18px;
`;
